<template>

    <!-- Page Title -->
    <section class="page-title centred" style="background-image: url(assets/images/background/page-title.jpg);">
        <div class="shape" style="background-image: url(assets/images/shape/banner-shap.png);"></div>
        <div class="auto-container">
            <div class="content-box">
                <h1>Contact Us</h1>
                <ul class="bread-crumb clearfix">
                    <li><router-link to="/">Home</router-link></li>
                    <li>Contact Us</li>
                </ul>
            </div>
        </div>
    </section>
    <!-- End Page Title -->

     <!-- contact-style-two -->
    <section class="contact-style-two">
        <div class="auto-container">
            <div class="row clearfix">
                <div class="col-lg-5 col-md-12 col-sm-12 info-column">
                    <div class="info-inner">
                        <div class="shape" style="background-image: url(assets/images/shape/shape-42.png);"></div>
                        <h3>Contact Information</h3>
                        <ul class="info-list clearfix">
                            <li>
                                <i class="fas fa-map-marker-alt"></i>
                                <h5>Office Location</h5>
                                <p>C-1401, Shilpan Prime,<br /> 80 feet Punit Nagar Road, <br />Mavdi, Rajkot 360005</p>
                            </li>
                            <li>
                                <i class="fas fa-envelope-open"></i>
                                <h5>Email Drop Us</h5>
                                <p><a href="mailto:info@aksharwatertech.in">info@aksharwatertech.in</a></p>
                            </li>
                            <li>
                                <i class="fas fa-phone"></i>
                                <h5>Call for Help</h5>
                                <p><a href="tel:+919726467383">+(91) 97264 67383</a></p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-7 col-md-12 col-sm-12 form-column">
                    <div class="form-inner">
                        <h3>Leave a Comment</h3>
                        <form @submit.prevent="handleSubmit" id="contact-form" class="default-form">
                            <div class="row clearfix">
                            <div class="col-lg-6 col-md-6 col-sm-12 form-group">
                                <input
                                type="text"
                                v-model="form.username"
                                placeholder="Your Name"
                                required
                                />
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 form-group">
                                <input
                                type="email"
                                v-model="form.email"
                                placeholder="Email Address"
                                required
                                />
                            </div>

                            <div class="col-lg-6 col-md-12 col-sm-12 form-group">
                                <input
                                type="text"
                                v-model="form.phone"
                                placeholder="Phone Number"
                                required
                                />
                            </div>

                            <div class="col-lg-6 col-md-12 col-sm-12 form-group">
                                <input
                                type="text"
                                v-model="form.subject"
                                placeholder="Subject"
                                required
                                />
                            </div>

                            <div class="col-lg-12 col-md-12 col-sm-12 form-group">
                                <textarea
                                v-model="form.message"
                                placeholder="Leave A Comment"
                                ></textarea>
                            </div>

                            <div class="col-lg-12 col-md-12 col-sm-12 form-group message-btn">
                                <button class="theme-btn btn-one" type="submit">Submit Now</button>
                            </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- contact-style-two end -->


    <!-- google-map-section -->
    <section class="google-map-section">
        <div class="auto-container">
            <div class="map-inner">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3692.849407184943!2d70.78554117586542!3d22.24579184486784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959cbe381c861e7%3A0xc8e1bc516d5a38bf!2sShilpan%20PRIME!5e0!3m2!1sen!2sin!4v1755154455523!5m2!1sen!2sin" width="1200" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                <!-- <div 
                    class="google-map" 
                    id="contact-google-map" 
                    data-map-lat="22.245866647380677" 
                    data-map-lng="70.78811963359675" 
                    data-icon-path="/assets/images/icons/map-marker.png"  
                    data-map-title="C-1401, Shilpan Prime, 80 feet Punit Nagar Road, Mavdi, Rajkot 360004" 
                    data-map-zoom="12" 
                    data-markers='{
                        "marker-1": [22.245866647380677, 70.78811963359675, "<h4>Office</h4><p>C-1401, Shilpan Prime, 80 feet Punit Nagar Road, Mavdi, Rajkot 360004</p>","assets/images/icons/map-marker.png"]
                    }'>

                </div> -->
            </div>
        </div>
    </section>
    <!-- google-map-section -->

</template>

<script setup>
import { onMounted } from 'vue'
import { useHead } from '@unhead/vue'
import { ref } from 'vue'

const form = ref({
  username: '',
  email: '',
  phone: '',
  subject: '',
  message: ''
})


useHead({
  title: 'Contact Us - Akshar Watertech',
  meta: [
    {
      name: 'description',
      content: 'Welcome to Akshar.',
    },
  ],
})

onMounted(() => {
    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
    // Replace it: remove and re-add
    existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)

})

function handleSubmit() {
  console.log('Form submitted:', form)
  // Example: Send data to API
  // fetch('/api/contact', {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify(form)
  // })
  //   .then(res => res.json())
  //   .then(data => console.log(data))
  //   .catch(err => console.error(err))
  
  alert('Form submitted successfully!')
}
</script>